import {
  Button,
  Center,
  Flex,
  Image,
  Input,
  InputGroup,
  InputLeftAddon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Spinner,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { AiFillPlusCircle } from 'react-icons/ai'
import { FiUpload } from 'react-icons/fi'
import * as S from '../../styles'
import { useEffect, useState } from 'react'
import { user } from '../../../../../helpers/user'
import Axios from 'axios'
import { ListaConfigProdutos } from '../../../../../services/api'
import { useDebounce } from '../../../../../hooks/useDebounce'
import { InputDragAndDrop } from '../InputDragAndDrop'
import { ModalSlideImages } from '../ModalSlideImages'
import { useMutation, useQueryClient } from 'react-query'

export function ModalNewProduct({ selectedField }) {
  const label = selectedField === 'innovationBrindes' ? 'Innovation Brindes' : 'Innovation Store'

  const [images, setImages] = useState([])
  const [productDetails, setProductDetails] = useState(null)
  const [open, setOpen] = useState(false)
  const [loadingProductDetails, setLoadingProductDetails] = useState(false)
  const [search, setSearch] = useState('')
  const [progress, setProgress] = useState(0)

  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(async () => {
    const formData = new FormData()

    formData.append('codigo_usuario', codUsu)

    formData.append('codigo_produto', productDetails?.codigo_produto)

    images.forEach((image, index) => {
      formData.append(`imagem[]`, image)
    })

    const urlComplete = label === 'Innovation Store' ? '-store' : ''

    const url = `${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-imagem/upload-imagens-produtos-s3${urlComplete}`

    const response = await Axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent

        let percent = Math.floor((loaded * 100) / total)

        setProgress(percent)
      },
    })

    onClose()
    setImages([])
    setProgress(0)
    setProductDetails(null)
    setSearch('')

    queryClient.invalidateQueries('images-upload-production')

    toast({
      title: 'Imagens enviadas com sucesso',
      description: 'As imagens foram enviadas com sucesso',
      status: 'success',
      duration: 9000,
      isClosable: true,
      position: 'top-right',
    })
  })

  const debouncedSearchTerm = useDebounce(search, 500)

  const { isOpen, onOpen, onClose } = useDisclosure({
    onOpen: () => {
      setOpen(true)
      setLoadingProductDetails(false)
    },
    onClose: () => {
      setOpen(false)
      setSearch('')
      setProductDetails(null)
      setImages([])
      setProgress(0)
    },
  })

  async function getProductDetails(diretorio) {
    const response = await ListaConfigProdutos.get('/' + diretorio)

    return response.data
  }

  async function getDetails(codprod) {
    try {
      setLoadingProductDetails(true)
      const response = await getProductDetails(codprod)

      if (response === 'Produto Inativo') {
        toast({
          title: 'Produto inativo',
          description: 'O produto está inativo, ative ele para continuar',
          status: 'error',
          duration: 20000,
          isClosable: true,
          position: 'top',
        })

        setLoadingProductDetails(false)
        setProductDetails(null)

        return
      }

      setProductDetails(response)
      setLoadingProductDetails(false)
    } catch (error) {
      console.log(error)
      setLoadingProductDetails(false)
      setProductDetails(null)
    }
  }

  useEffect(() => {
    getDetails(debouncedSearchTerm)
  }, [debouncedSearchTerm])

  const codUsu = user?.codigo_usuario

  const toast = useToast()

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files)
    setImages(files)
  }

  const caracteristicas =
    productDetails?.caracteristicas?.length > 30 ? productDetails?.caracteristicas.substring(0, 30) + '...' : productDetails?.caracteristicas

  const listImages = label === 'Innovation Store' ? productDetails?.imagens_produto_store : productDetails?.imagens_produto

  const listInitialImage = label === 'Innovation Store' ? productDetails?.imagem_home_store : productDetails?.imagem_produto

  return (
    <>
      <Button onClick={onOpen}>
        <Flex gap={2} align="center" color="#378BBF">
          <AiFillPlusCircle size={20} />
          Adicionar novo - {label}
        </Flex>
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nova pasta de Imagens - {label}</ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" flexDir="column" w="100%" gap={4}>
            <Flex bgColor="#fff" flex={1} borderRadius="md" boxShadow="0 0 3px rgba(0,0,0,.1)" flexDir="column" alignItems="center" height="153px">
              <Flex flexDir="column" maxWidth="400px" p="1rem" gap={2}>
                <Text as="h1" fontSize="1.2rem" fontWeight="bold" color="gray.700" textAlign="center">
                  Pesquise por código do produto
                </Text>
                <InputGroup>
                  <InputLeftAddon children="Cod. prod." />
                  <Input placeholder="Pesquisar..." onChange={(e) => setSearch(e.target.value)} />
                </InputGroup>
              </Flex>
            </Flex>
            {loadingProductDetails && (
              <Center>
                <Spinner thickness="4px" color="blue.400" size="xl" />
              </Center>
            )}
            {!loadingProductDetails && productDetails && (
              <Flex flexDir="column">
                <Flex
                  justifyContent="flex-start"
                  w="100%"
                  boxShadow="0 0 0 1px rgba(0,0,0,0.1)"
                  borderRadius="md"
                  p="1rem"
                  mb="1rem"
                  bg="gray.50"
                  gap={5}
                >
                  <Flex w="200px">
                    <Image
                      src={listInitialImage}
                      _loading={{
                        src: '/images/loading-blue.gif',
                      }}
                      fallbackSrc="/images/loading-blue.gif"
                      alt="pasta"
                      cursor="pointer"
                      transition="all 0.1s"
                      _hover={{
                        transform: 'scale(1.1)',
                      }}
                    />
                  </Flex>
                  <Flex flexDir="column">
                    <Text>
                      Produto:{' '}
                      <Text as="span" color="blue.800" fontWeight="bold">
                        {productDetails?.nome}
                      </Text>
                    </Text>
                    <Tooltip label={productDetails?.caracteristicas} aria-label="A tooltip">
                      <Text>
                        Características:{' '}
                        <Text as="span" color="blue.800" fontWeight="bold">
                          {caracteristicas}
                        </Text>
                      </Text>
                    </Tooltip>

                    <Text>
                      Dimensões:{' '}
                      <Text as="span" color="blue.800" fontWeight="bold">
                        {productDetails?.dimensoes}
                      </Text>
                    </Text>
                    <Text>
                      Quantidade de imagens:{' '}
                      <Text as="span" color="blue.800" fontWeight="bold">
                        {productDetails?.imagens_produto_store?.length}
                      </Text>
                    </Text>
                  </Flex>
                </Flex>

                <Flex
                  justifyContent="flex-start"
                  w="100%"
                  boxShadow="0 0 0 1px rgba(0,0,0,0.1)"
                  borderRadius="md"
                  p="1rem"
                  mb="1rem"
                  bg="gray.50"
                  flexWrap="wrap"
                  gap={2}
                >
                  <ModalSlideImages images={listImages} />
                </Flex>
                <Center mb="1rem">Cadastrar mais imagens</Center>
                {progress > 0 && <Progress hasStripe value={progress} mb="1rem" />}
                <InputDragAndDrop images={images} setImages={setImages} />
                {/* <Flex mb="1rem" w="100%" flexDir="column" gap={2} as="form">
                  <S.Inputas
                    id={`aws-upload-item`}
                    type="file"
                    multiple
                    onChange={handleImageChange}
                  />
                  <S.Label htmlFor={`aws-upload-item`}>
                    {' '}
                    <S.Textas>
                      {!images.length
                        ? `Selecione uma ou mais fotos do produto - ${productDetails?.codigo_produto}`
                        : `${images.length} imagens selecionadas`}
                    </S.Textas>
                    <FiUpload />
                  </S.Label>
                </Flex> */}
              </Flex>
            )}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" ml="auto" disabled={images.length === 0} isLoading={isLoading} loadingText="Enviando" onClick={mutate}>
              Enviar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
